import { Icon, type IconProps } from './Icon';

interface SpeakerProps extends IconProps {
  /** Struck through: the sound is off. */
  muted?: boolean;
}

/** A loudspeaker, with sound waves or a strike-through. */
export function Speaker({ muted = false, ...props }: SpeakerProps) {
  return (
    <Icon {...props}>
      <path d="M4 9.5v5h3.5L12 18.5v-13L7.5 9.5z" />
      {muted ? (
        <path d="M16 9.5l5 5M21 9.5l-5 5" />
      ) : (
        <>
          <path d="M15.5 9.5a3.5 3.5 0 010 5" />
          <path d="M18 7a7 7 0 010 10" />
        </>
      )}
    </Icon>
  );
}
